import { useTypeNames as useCoreTypeNames } from '@fv/client-core'

import { useAppSettings } from './useAppSettings'

export function useTypeNames() {
  return useCoreTypeNames(useAppSettings)
}
